import { render } from "./IconThumbMedium.vue?vue&type=template&id=d4f5a1ea"
const script = {}

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__